<template>
  <div class="premium-features-block">
    <div class="premium-title">
      {{$lang.messages.get_premium_modal.features.title}}
    </div>
    <div class="premium-feature flex" :key=feature.id v-for="feature in features">
      <div class="premium-feature-icon">
        <div :class="'icon-'+ feature.icon"></div>
      </div>
      <div class="premium-feature-content">
        <div class="premium-feature-title text-lg text-bold">{{feature.title}}</div>
        <div class="">
          <span class="premium-feature-text" :key=item.index v-for="item in feature.text">{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
 name: 'PremiumFeatures',
  data: function () {
    return {
      features: [
        {
          id: 0,
          title: this.$lang.messages.get_premium_modal.features.feture_1_title,
          icon: 'settings',
          text: this.$lang.messages.get_premium_modal.features.feture_1_texts
        },
        {
          id: 1,
          title: this.$lang.messages.get_premium_modal.features.feture_2_title,
          icon: 'themes',
          text: this.$lang.messages.get_premium_modal.features.feture_2_texts
        },
        {
          id: 2,
          title: this.$lang.messages.get_premium_modal.features.feture_3_title,
          icon: 'statistic',
          text: this.$lang.messages.get_premium_modal.features.feture_3_texts
        },
        {
          id: 3,
          title: this.$lang.messages.get_premium_modal.features.feture_4_title,
          icon: 'remote',
          text: this.$lang.messages.get_premium_modal.features.feture_4_texts
        }
      ],
    }
  },
}

</script>
